import { TestimonialPage } from './TestimonialPage';

export function EnrolmentMethodTestimonialPage() {
  return (
    <TestimonialPage
      trainingTypeOverride="new-model-enrolment-method"
      trainingLabelOverride="New Model of NLP Enrolment Method Training"
      description="We'd love to hear about your experience over the last two days of Enrolment Method training. Your words help others understand the value of this work."
    />
  );
}
